


<div  class="signature-activity-card  border-radius-smaller "
      [ngStyle]="{
        border: borderObs | async
      }"  
>

  <ss-core-loader-outlet [keys]="['task.insert.'+activity.id]" height="100%"></ss-core-loader-outlet>


  <div class="flex-column animate gap-none">
    <div class="flex-row flex--align-center gap-standard padding-standard"
         [ngStyle]="{
            'background-color':backgroundObs | async
         }"
    >
      <div 
        *ngIf="!(hideGroupSubject | async)"
        class="mat-headline-5 margin-none padding-none full-height"        
      >
          {{(activity.orderIndex + 1) +' '}} 
      </div>
      
      <div class="flex-column flex-1 gap-smaller padding-none">
        <div class="mat-body-1 light-bold" >{{activity.actor?.firstName + ' ' + activity.actor?.lastName}}</div>
  
        <div class="flex-row">
          <p class="mat-body-2 margin-none mat-mdc-card-subtitle">{{activity.actor?.email}}</p>
        </div>
      </div>
    </div>

    <div class="flex-row flex--justify-between flex--align-center padding-smaller-block padding-standard-inline border-gray-top">

      <button 
        mat-icon-button 
        color="primary" 
        class="no-padding-mat-icon-button"
        matTooltip="{{'ss-entities.task.signature.prev' | translate}}" 
        matTooltipHideDelay="100" 
        matTooltipPosition="below"
        (click)="prevSignature()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>

      <button 
          mat-icon-button
          (click)="dropSignature()"
          class="primary-text no-padding-mat-icon-button"
          matTooltip="{{'ss-entities.task.signature.drop' | translate}}" 
          matTooltipHideDelay="100" 
          matTooltipPosition="below"        
        >
        <mat-icon>add</mat-icon>
      </button>

      <button 
        mat-icon-button 
        class="no-padding-mat-icon-button" 
        color="primary" (click)="toggleShowSettings()"
      >
        <mat-icon>settings</mat-icon>
      </button>

      <button mat-icon-button
              color="primary" 
              class="no-padding-mat-icon-button"
              matTooltip="{{'ss-entities.task.signature.next' | translate}}" 
              matTooltipHideDelay="100" 
              matTooltipPosition="below"
              (click)="nextSignature()"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>

    </div>


    <ss-actor-settings class="border-primary-top" *ngIf="showSettingsSubject | async"></ss-actor-settings>
  </div>

</div>

